module.exports = __webpack_public_path__ + "img/graphic_icon_lock_.cb051ea5.png";